const WorkCardData = [
  {
    imgsrc: require("../../assets/pizza.jpeg"),
    title: "Martinelli Pizza Deli",
    text: "A singe page React application with routes, that displays the pizzarea's menu items and address as well as contact details",
    view: "https://marti-nelli.vercel.app/",
    source: "https://github.com/zoecabrales/MartinelliPizzaDeli",
    tools: "Tools Used: React CRA, Vercel for deployment",
  },
];

export default WorkCardData;
